import escapeRegExp from 'lodash/escapeRegExp'

// From the given "full" string, find "find" substring, replace as "replace" string only on "nth" occurrence
export const replaceNthSubstring = (full: string, find: string, replace: string, nth: number) => {
  const findEscaped = escapeRegExp(find)
  return full.replace(RegExp('^(?:.*?' + findEscaped + '){' + nth + '}'), (x) =>
    x.replace(RegExp(findEscaped + '$'), replace)
  )
}
